import { Button, ButtonVariant } from '@usealloy/component-library';
import {
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import KBAMultiStepForm, { KBAShape } from '~/evaluations/form/KBAMultiStepForm';
import AuthyMultiStepForm, { AuthyShape } from '~/evaluations/form/AuthyMultiStepForm';


const MultiStepModalPropTypes = {
  multiStep: PropTypes.shape({
    prompts: PropTypes.oneOfType([KBAShape, AuthyShape]),
  }).isRequired,
  submitMultiStep: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};


const MultiStepModal = ({ multiStep, submitMultiStep, closeModal }) => {
  const isKBA = multiStep.prompts.answers || false;

  // KBA answers
  const [answers, setAnswers] = useState({});
  const answersReady = isKBA
    && multiStep.prompts.answers.questions
      // Object.keys() implicitly converts numeric Object keys to strings.
      .every(question => Object.keys(answers).includes(String(question.id)));
  const handleKBAOptionClickClosure = (questionId, answerId) => () => {
    setAnswers(a => ({ ...a, [questionId]: answerId }));
  };


  // Authy verification code
  const [verificationCode, setVerificationCode] = useState('');
  const handleVerificationCodeChange = event => setVerificationCode(event.target.value);


  // Submitting
  const [submitting, setSubmitting] = useState(false);
  const responseReady = (answersReady || (!isKBA && verificationCode)) && !submitting;
  const submitResponse = () => {
    if (responseReady) {
      setSubmitting(true);
      // Convert state to correct format for API request body
      const response = isKBA
        ? {
          answers: Object.keys(answers).map(questionId => ({
            question_id: +questionId,
            answer_id: +answers[questionId],
          })),
        }
        : { verification_code: verificationCode };
      submitMultiStep(response, () => { setSubmitting(false); });
    }
  };


  return multiStep && (
    <Modal
      id="kba-modal"
      isOpen={multiStep && multiStep.prompts}
      toggle={closeModal}
    >
      <div className="modal-header">
        <Button className="close" onClick={closeModal}>
          <i className="far fa-fw fa-times" />
        </Button>
      </div>

      <ModalBody>
        {isKBA ? (
          <KBAMultiStepForm
            prompts={multiStep.prompts}
            answers={answers}
            handleKBAOptionClickClosure={handleKBAOptionClickClosure}
          />
        ) : (
          <AuthyMultiStepForm
            prompts={multiStep.prompts}
            verificationCode={verificationCode}
            handleVerificationCodeChange={handleVerificationCodeChange}
          />
        )}
      </ModalBody>

      <ModalFooter>
        <Button
          disabled={!responseReady}
          onClick={submitResponse}
          variant={ButtonVariant.primary}
        >
          {submitting ? 'Submission in Progress...' : 'Submit Responses'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

MultiStepModal.propTypes = MultiStepModalPropTypes;


export default MultiStepModal;
